import cn from 'classnames';
import React, { Component } from 'react';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';

import styles from './Deadline.scss';
import tracker from '../../../../../services/tracker';
import i18n from '../../../../../i18n';
import { withTranslation } from 'react-i18next';

const variants = [
  {
    key: 'deadlineEnd',
    text: i18n.t('components.header.filtersBar.filters.deadline.finished'),
    event: 'Web_Filters_Passed'
  },
  {
    key: '2021/1/2/3/4',
    text: '2021',
    event: 'Web_Filters_2021'
  },
  {
    key: '2022/1/2/3/4',
    text: '2022',
    event: 'Web_Filters_2022'
  },
  {
    key: '2023/1/2/3/4',
    text: '2023',
    event: 'Web_Filters_2023'
  },
  {
    key: '2024/1/2/3/4',
    text: '2024',
    event: 'Web_Filters_2024'
  },
  {
    key: '2025/1/2/3/4',
    text: '2025',
    event: 'Web_Filters_2025'
  },
  {
    key: '2026/1/2/3/4',
    text: '2026',
    event: 'Web_Filters_2026'
  },
  {
    key: '2027/1/2/3/4',
    text: '2027',
    event: 'Web_Filters_2027'
  }
];

export const parseSearch = (search) => {
  const { deadline } = search;
  if (!deadline) {
    return { deadline: [] };
  }
  return { deadline: deadline.split(',') };
};

export const compileSearch = (data) => {
  const { deadline: keys } = data;
  if (!keys.length) {
    return { deadline: undefined };
  }
  return {
    deadline: keys.join(',') || undefined
  };
};

export const compileRequest = (data) => {
  const { deadline: keys } = data;
  const deadline = [...keys];
  let deadlineEnd = false;
  if (deadline.includes('deadlineEnd')) {
    deadline.splice(deadline.indexOf('deadlineEnd'), 1);
    deadlineEnd = true;
  }
  return { deadline: deadline.length ? deadline : undefined, deadlineEnd };
};

export const getRequest = (search) => compileRequest(parseSearch(search));

export const subtext = (search) => {
  const { deadline: keys } = parseSearch(search);
  const deadline = [...keys];

  const subtext = deadline.map((key) => {
    const oldDate = key.split('/');
    const newDate = oldDate.slice(1);
    if (oldDate.length > 1) {
      return i18n.t('components.header.filtersBar.filters.deadline.quarter', {
        data: `\`${oldDate[0]} - ${newDate.join(', ')}`
      });
    }
    return variants.find(variant => variant.key === key).text;
  });
  return subtext.join(', ') || i18n.t('components.header.filtersBar.filters.deadline.notSelected');
};

function isIncludes({ deadline, key }) {
  return deadline.some(date => {
    const splitedDate = date.split('/');
    const splitedKey = key.split('/');
    return splitedKey.every(elem => splitedDate.includes(elem));
  });
}

function removeFromDeadline({ deadline, key, isGroup }) {
  const newDeadline = [];
  deadline.forEach(date => {
    const splitedDate = date.split('/');
    const splitedKey = key.split('/');

    if (splitedKey.every(elem => splitedDate.includes(elem))) {
      if (!isGroup) {
        delete splitedKey[0];
        const newDeadlineDate = splitedDate.filter(val => !splitedKey.includes(val));

        if (newDeadlineDate.length > 1) {
          return newDeadline.push(newDeadlineDate.join('/'));
        }
        return;
      }
      return;
    }
    return newDeadline.push(date);
  });

  return newDeadline;
}

function addToDeadline({ deadline, key, isGroup }) {
  let newDeadline = [];
  const splitedKey = key.split('/');
  let nooneDateStartsWithKey = true;

  deadline.forEach(date => {
    const splitedDate = date.split('/');
    if (splitedDate[0] === splitedKey[0]) {
      nooneDateStartsWithKey = false;
      if (isGroup) {
        return newDeadline.push(key);
      }
      splitedDate.push(splitedKey[1]);
      return newDeadline.push(splitedDate.join('/'));
    }
    return newDeadline.push(date);
  });

  if (nooneDateStartsWithKey) {
    newDeadline = [...deadline, key];
  }

  return newDeadline;
}

function isGroupPartialChecked({ deadline, key }) {
  return deadline.some(date => {
    const splitedDate = date.split('/');
    const splitedKey = key.split('/');
    return splitedDate.includes(splitedKey[0]);
  });
}

class Deadline extends Component {
  constructor(props) {
    super(props);

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.handleToggleSectionClick = this.handleToggleSectionClick.bind(this);

    this.state = {
      isToggle2021: false,
      isToggle2022: false,
      isToggle2023: false,
      isToggle2024: false,
      isToggle2025: false,
      isToggle2026: false,
      isToggle2027: false
    };
  }
  UNSAFE_componentWillMount() {
    const { search } = this.props;
    const { deadline } = parseSearch(search);
    if (deadline.length) {
      for (let i = 0; i < deadline.length; i++) {
        if (~deadline[i].indexOf('2021')) {
          this.setState({ isToggle2021: true });
        }
        if (~deadline[i].indexOf('2022')) {
          this.setState({ isToggle2022: true });
        }
        if (~deadline[i].indexOf('2023')) {
          this.setState({ isToggle2023: true });
        }
        if (~deadline[i].indexOf('2024')) {
          this.setState({ isToggle2024: true });
        }
        if (~deadline[i].indexOf('2025')) {
          this.setState({ isToggle2025: true });
        }
        if (~deadline[i].indexOf('2026')) {
          this.setState({ isToggle2026: true });
        }
        if (~deadline[i].indexOf('2027')) {
          this.setState({ isToggle2027: true });
        }
      }
    }
  }

  handleClearClick() {
    const { dropdownData } = this.props;
    const data = { deadline: [] };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
    this.props.onClearClick && this.props.onClearClick('deadline');
  }

  handleCheckboxClick({ key, isGroup }, add) {
    const { search, dropdownData, eventData } = this.props;
    const { deadline: keys } = parseSearch(search);
    let deadline = [...keys];

    tracker.sendVariantEvent({ variants, key, selected: add, eventData });

    if (isIncludes({ deadline, key, isGroup }) !== add) {
      if (add) {
        deadline = deadline.length ? addToDeadline({ deadline, key, isGroup }) : [key];
      } else {
        deadline = removeFromDeadline({ deadline, key, isGroup });
      }
    }
    const data = { deadline };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  handleCheckboxForNonNumValueClick = (key, add) => {
    const { search, dropdownData } = this.props;
    const { deadline: keys } = parseSearch(search);
    const deadline = [...keys];
    if (deadline.includes(key) !== add) {
      if (add) {
        deadline.push(key);
      } else {
        deadline.splice(deadline.indexOf(key), 1);
      }
    }

    tracker.sendEvent('Web_Filters_Passed', {
      mode: window.location.search.includes('view=map') ? 'map' : 'list',
      checked: add
    });

    const data = { deadline };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key, isGroup) {
    const { search, additional, t } = this.props;
    const { deadline } = parseSearch(search);
    const date = key.split('/');
    const year = date[0];
    const period = date[1];

    const isChecked = isIncludes({ deadline, key, isGroup });
    const checkboxProps = {};
    if (isGroup) {
      checkboxProps.partialChecked = isGroupPartialChecked({ deadline, key });
    }

    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={isChecked}
        {...checkboxProps}
        additional={additional}
        handle={this.handleCheckboxClick.bind(undefined, { key, isGroup })}
        text={date.length < 5 ? t('components.header.filtersBar.filters.deadline.quarter', { data: period }) : year}
      />
    );
  }

  handleToggleSectionClick(year) {
    if (this.state[year]) {
      this.setState({ [year]: false });
    } else {
      this.setState({ [year]: true });
    }

    // this.setState(prevState => ({
    //   [year]: !prevState[year]
    // }));
  }

  render() {
    const { className, search, additional, t } = this.props;
    const { deadline } = parseSearch(search);

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        <p className={styles.Title}>
          {t('components.header.filtersBar.filters.deadline.title')}
          {
            !!deadline.length &&
            <Button className={styles.Button} onClick={this.handleClearClick}>
              {t('components.header.filtersBar.filters.deadline.clear')}
            </Button>
          }
        </p>
        <div className={styles.Checkboxes}>
          <Checkbox
            className={styles.Checkbox}
            innerStyle={styles.FiltersCheckInner}
            classNameClone="CheckboxCloneFilters"
            checked={deadline.includes('deadlineEnd')}
            additional={additional}
            handle={this.handleCheckboxForNonNumValueClick.bind(undefined, 'deadlineEnd')}
            text={t('components.header.filtersBar.filters.deadline.finished')}
          />
          <div className={styles.DeadlineSection}>
            <div className={styles.DeadlineSectionHead}>
              {this.checkbox('2021/1/2/3/4', true)}
              <div className={cn(styles.DeadlineSectionToggle, { [styles.Active]: this.state.isToggle2021 })} onClick={() => this.handleToggleSectionClick('isToggle2021')}><span className={styles.Plus}>+</span><span className={styles.Minus}>-</span></div>
            </div>
            <div className={cn(styles.DeadlineSectionBody, { [styles.Active]: this.state.isToggle2021 })}>
              <div className={styles.FirstColumn}>
                {this.checkbox('2021/1')}
                {this.checkbox('2021/3')}
              </div>
              <div className={styles.SecondColumn}>
                {this.checkbox('2021/2')}
                {this.checkbox('2021/4')}
              </div>
            </div>
          </div>
          <div className={styles.DeadlineSection}>
            <div className={styles.DeadlineSectionHead}>
              {this.checkbox('2022/1/2/3/4', true)}
              <div className={cn(styles.DeadlineSectionToggle, { [styles.Active]: this.state.isToggle2022 })} onClick={() => this.handleToggleSectionClick('isToggle2022')}><span className={styles.Plus}>+</span><span className={styles.Minus}>-</span></div>
            </div>
            <div className={cn(styles.DeadlineSectionBody, { [styles.Active]: this.state.isToggle2022 })}>
              <div className={styles.FirstColumn}>
                {this.checkbox('2022/1')}
                {this.checkbox('2022/3')}
              </div>
              <div className={styles.SecondColumn}>
                {this.checkbox('2022/2')}
                {this.checkbox('2022/4')}
              </div>
            </div>
          </div>
          <div className={styles.DeadlineSection}>
            <div className={styles.DeadlineSectionHead}>
              {this.checkbox('2023/1/2/3/4', true)}
              <div className={cn(styles.DeadlineSectionToggle, { [styles.Active]: this.state.isToggle2023 })} onClick={() => this.handleToggleSectionClick('isToggle2023')}><span className={styles.Plus}>+</span><span className={styles.Minus}>-</span></div>
            </div>
            <div className={cn(styles.DeadlineSectionBody, { [styles.Active]: this.state.isToggle2023 })}>
              <div className={styles.FirstColumn}>
                {this.checkbox('2023/1')}
                {this.checkbox('2023/3')}
              </div>
              <div className={styles.SecondColumn}>
                {this.checkbox('2023/2')}
                {this.checkbox('2023/4')}
              </div>
            </div>
          </div>
          <div className={styles.DeadlineSection}>
            <div className={styles.DeadlineSectionHead}>
              {this.checkbox('2024/1/2/3/4', true)}
              <div className={cn(styles.DeadlineSectionToggle, { [styles.Active]: this.state.isToggle2024 })} onClick={() => this.handleToggleSectionClick('isToggle2024')}><span className={styles.Plus}>+</span><span className={styles.Minus}>-</span></div>
            </div>
            <div className={cn(styles.DeadlineSectionBody, { [styles.Active]: this.state.isToggle2024 })}>
              <div className={styles.FirstColumn}>
                {this.checkbox('2024/1')}
                {this.checkbox('2024/3')}
              </div>
              <div className={styles.SecondColumn}>
                {this.checkbox('2024/2')}
                {this.checkbox('2024/4')}
              </div>
            </div>
          </div>
          <div className={styles.DeadlineSection}>
            <div className={styles.DeadlineSectionHead}>
              {this.checkbox('2025/1/2/3/4', true)}
              <div className={cn(styles.DeadlineSectionToggle, { [styles.Active]: this.state.isToggle2025 })} onClick={() => this.handleToggleSectionClick('isToggle2025')}><span className={styles.Plus}>+</span><span className={styles.Minus}>-</span></div>
            </div>
            <div className={cn(styles.DeadlineSectionBody, { [styles.Active]: this.state.isToggle2025 })}>
              <div className={styles.FirstColumn}>
                {this.checkbox('2025/1')}
                {this.checkbox('2025/3')}
              </div>
              <div className={styles.SecondColumn}>
                {this.checkbox('2025/2')}
                {this.checkbox('2025/4')}
              </div>
            </div>
          </div>
          <div className={styles.DeadlineSection}>
            <div className={styles.DeadlineSectionHead}>
              {this.checkbox('2026/1/2/3/4', true)}
              <div className={cn(styles.DeadlineSectionToggle, { [styles.Active]: this.state.isToggle2026 })} onClick={() => this.handleToggleSectionClick('isToggle2026')}><span className={styles.Plus}>+</span><span className={styles.Minus}>-</span></div>
            </div>
            <div className={cn(styles.DeadlineSectionBody, { [styles.Active]: this.state.isToggle2026 })}>
              <div className={styles.FirstColumn}>
                {this.checkbox('2026/1')}
                {this.checkbox('2026/3')}
              </div>
              <div className={styles.SecondColumn}>
                {this.checkbox('2026/2')}
                {this.checkbox('2026/4')}
              </div>
            </div>
          </div>
          <div className={styles.DeadlineSection}>
            <div className={styles.DeadlineSectionHead}>
              {this.checkbox('2027/1/2/3/4', true)}
              <div className={cn(styles.DeadlineSectionToggle, { [styles.Active]: this.state.isToggle2027 })} onClick={() => this.handleToggleSectionClick('isToggle2027')}><span className={styles.Plus}>+</span><span className={styles.Minus}>-</span></div>
            </div>
            <div className={cn(styles.DeadlineSectionBody, { [styles.Active]: this.state.isToggle2027 })}>
              <div className={styles.FirstColumn}>
                {this.checkbox('2027/1')}
                {this.checkbox('2027/3')}
              </div>
              <div className={styles.SecondColumn}>
                {this.checkbox('2027/2')}
                {this.checkbox('2027/4')}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Deadline);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Deadline/Deadline.js